import { render, staticRenderFns } from "./CertificatesCreateModal.vue?vue&type=template&id=1c880d89&"
import script from "./CertificatesCreateModal.vue?vue&type=script&lang=js&"
export * from "./CertificatesCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports